// extracted by mini-css-extract-plugin
export default {"roles-select":"roles_roles-select__sqw5u","card-container":"roles_card-container__FsDPF"};